/**
 * Created by maximus on 14.10.16.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _helpers = require('helpers');

var _auth = require('redux/actions/auth');

var _modal_type = require('redux/actions/modal_type');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Hamburger: {
        displayName: 'Hamburger'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Hamburger/Hamburger.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var Hamburger = _wrapComponent('Hamburger')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        categories: state.catalog.categories,
        lang: state.lang
    };
}, {
    logout: _auth.logout, showModalAuth: _modal_type.showModalAuth, showModalRegistration: _modal_type.showModalRegistration
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(Hamburger, _Component);

    function Hamburger(props) {
        (0, _classCallCheck3.default)(this, Hamburger);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Hamburger.__proto__ || (0, _getPrototypeOf2.default)(Hamburger)).call(this, props));

        _this.handleCloseHamburger = function () {
            var handleClick = _this.props.handleClick;

            handleClick();
            document.documentElement.classList.remove('scroll_hide');
            _this.setState({ showCatalog: false });
        };

        _this.handleCatalogClick = function (e) {
            e.preventDefault();
            _this.setState({ showCatalog: "catalog" });
        };

        _this.handleBackClick = function () {
            _this.setState({ showCatalog: false });
        };

        _this.handleMyMenuClick = function () {
            _this.setState({ showCatalog: "menu" });
        };

        _this.handleLogout = function () {
            _this.props.logout();
            _this.handleCloseHamburger();
        };

        _this.state = {
            showCatalog: false
        };
        return _this;
    }

    (0, _createClass3.default)(Hamburger, [{
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('Hamburger'),
                _props = this.props,
                categories = _props.categories,
                logo = _props.logo,
                phone = _props.phone,
                show = _props.show,
                pages = _props.pages,
                title = _props.title,
                user = _props.user,
                lang = _props.lang,
                visible = show || false,
                hamburgerClass = visible ? "hamburger" : "hamburger hamburger_hide";


            var hiddenArea = void 0;

            if (visible) {
                hiddenArea = _react3.default.createElement(
                    'div',
                    { className: 'invisible-area', onClick: this.handleCloseHamburger },
                    _react3.default.createElement('div', { className: 'invisible-area-before-hamburger' })
                );
            }

            return _react3.default.createElement(
                'div',
                { className: 'Header__hamburger Hamburger wrap-hamburger' },
                hiddenArea,
                _react3.default.createElement(View, {
                    categories: categories,
                    hamburgerClass: hamburgerClass,
                    logo: logo,
                    phone: phone,
                    pages: pages,
                    title: title,
                    showCatalog: this.state.showCatalog,
                    user: user,
                    close: this.handleCloseHamburger,
                    handleBackClick: this.handleBackClick,
                    handleCatalogClick: this.handleCatalogClick,
                    handleAuthClick: this.props.showModalAuth,
                    handleMyMenuClick: this.handleMyMenuClick,
                    handleRegisterClick: this.props.showModalRegistration,
                    logout: this.handleLogout,
                    lang: lang
                })
            );
        }
    }]);
    return Hamburger;
}(_react2.Component), _class2.propTypes = {
    handleClick: _react2.PropTypes.func.isRequired,
    logo: _react2.PropTypes.string.isRequired,
    phone: _react2.PropTypes.string,
    show: _react2.PropTypes.bool.isRequired,
    title: _react2.PropTypes.string.isRequired,
    lang: _react2.PropTypes.object
}, _temp)) || _class));

exports.default = Hamburger;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Hamburger/Hamburger.jsx
// module id = 1667
// module chunks = 0